import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import { ECOMMERCE_PRODUCT_MENU_KEY, ECOMMERCE_CART_MENU_KEY, ECOMMERCE_ORDER_MENU_KEY, CUSTOMER_SEGMENT, ECOMMERCE_MARKETING_MENU_KEY, } from '@/helpers/constants/app';
let MainDistributorBundle = class MainDistributorBundle extends Mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.toggleProductsMenu = false;
        this.toggleCartMenu = false;
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get cartMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_CART_MENU_KEY;
    }
    get productMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_PRODUCT_MENU_KEY;
    }
    get orderMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_ORDER_MENU_KEY;
    }
    get marketingMenuIsActive() {
        return this.currentRoute.meta.parentMenu === ECOMMERCE_MARKETING_MENU_KEY;
    }
    get ecommerceMenuItems() {
        const params = {
            appUUID: this.appUuid,
        };
        let items = [];
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            const { productComponent } = this.appDetails;
            items = [
                this.productMenu(productComponent.uuid),
                ...this.buildDefaultMenu({ ...params, componentUUID: productComponent.uuid }),
            ];
        }
        const menuItems = items.length >= 1 ? items : this.buildDefaultMenu(params);
        return [
            {
                icon_path: require('./assets/overview.svg'),
                text: 'Overview',
                path: {
                    name: 'main-distributor-overview',
                    params,
                },
                exact: false,
            },
            ...menuItems,
        ];
    }
    /**
     * Default Menu Items Builder
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version 0.1.6
     *
     * @returns {Menu[]} list of menu items
     */
    buildDefaultMenu(params) {
        return [
            {
                icon_path: require('./assets/cart.svg'),
                text: 'Checkout Settings',
                model: this.cartMenuIsActive,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Settings',
                        path: {
                            name: 'main-distributor-cart-settings',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Delivery Areas',
                        path: {
                            name: 'main-distributor-delivery-areas',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
            {
                icon_path: require('./assets/order.svg'),
                text: 'Orders',
                model: this.orderMenuIsActive,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Order Tracker',
                        path: {
                            name: 'main-distributor-orders-by-status',
                            params: { status: 'pending' },
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Order History',
                        path: {
                            name: 'main-distributor-order-history',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
            {
                icon_path: require('./assets/distributor-icon.svg'),
                text: 'Distributor Manager',
                path: {
                    name: 'main-distributor-distributor-manager',
                    params,
                },
                exact: false,
            },
            {
                icon_path: require('./assets/shipping.svg'),
                text: 'Shipping Manager',
                path: {
                    name: 'main-distributor-shipping',
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/payment.svg'),
                text: 'Payment Manager',
                path: {
                    name: 'main-distributor-payment',
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/broadcast.svg'),
                text: 'Marketing Tools',
                model: this.marketingMenuIsActive,
                children: [
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Referral',
                        path: {
                            name: 'main-distributor-referral',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Comment Auto-Reply',
                        path: {
                            name: 'ecommerce-affiliate-automation',
                            params,
                        },
                        exact: true,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: CUSTOMER_SEGMENT,
                        path: {
                            name: 'main-distributor-customers',
                            params,
                        },
                        exact: false,
                    },
                    // {
                    //   icon: this.childrenMenuIcon,
                    //   text: 'Broadcast',
                    //   path: {
                    //     name: 'main-distributor-broadcasts',
                    //     params,
                    //   },
                    //   exact: false,
                    // },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Discounts Manager',
                        path: {
                            name: 'main-distributor-promos',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Promos',
                        path: {
                            name: 'main-distributor-cart-promos',
                            params,
                        },
                        exact: false,
                    },
                    {
                        icon: this.childrenMenuIcon,
                        text: 'Meta Ad Settings',
                        path: {
                            name: 'meta-add-settings',
                            params,
                        },
                        exact: false,
                    },
                ],
            },
        ];
    }
    productMenu(productUuid) {
        const params = {
            appUUID: this.appUuid,
            componentUUID: productUuid,
        };
        return {
            icon_path: require('./assets/products.svg'),
            text: 'Product Manager',
            model: this.productMenuIsActive,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: 'Categories',
                    path: {
                        name: 'main-distributor-categories',
                        params,
                    },
                    exact: true,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: 'Products',
                    path: {
                        name: 'main-distributor-products',
                        params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: 'Add - Ons / Upsell',
                    path: {
                        name: 'main-distributor-add-ons',
                        params,
                    },
                    exact: false,
                },
            ],
        };
    }
};
MainDistributorBundle = __decorate([
    Component
], MainDistributorBundle);
export default MainDistributorBundle;
